export const ConnectionsPageLogo = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1406_7475)">
      <g clipPath="url(#clip1_1406_7475)">
        <path
          d="M1.875 8.5H18.125L10 3.5L1.875 8.5Z"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.375 8.5V14.75"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.125 8.5V14.75"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.875 8.5V14.75"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.5735 9L15.5735 13"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.5 14.75H13.75"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2 17L11 17"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <g clipPath="url(#clip2_1406_7475)">
        <path
          d="M15.875 18.25H14C13.4033 18.25 12.831 18.0129 12.409 17.591C11.9871 17.169 11.75 16.5967 11.75 16C11.75 15.4033 11.9871 14.831 12.409 14.409C12.831 13.9871 13.4033 13.75 14 13.75H15.875"
          fill="white"
        />
        <path
          d="M15.875 18.25H14C13.4033 18.25 12.831 18.0129 12.409 17.591C11.9871 17.169 11.75 16.5967 11.75 16C11.75 15.4033 11.9871 14.831 12.409 14.409C12.831 13.9871 13.4033 13.75 14 13.75H15.875"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.125 13.75H20C20.5967 13.75 21.169 13.9871 21.591 14.409C22.0129 14.831 22.25 15.4033 22.25 16C22.25 16.5967 22.0129 17.169 21.591 17.591C21.169 18.0129 20.5967 18.25 20 18.25H18.125"
          fill="white"
        />
        <path
          d="M18.125 13.75H20C20.5967 13.75 21.169 13.9871 21.591 14.409C22.0129 14.831 22.25 15.4033 22.25 16C22.25 16.5967 22.0129 17.169 21.591 17.591C21.169 18.0129 20.5967 18.25 20 18.25H18.125"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 16H19.5"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1406_7475">
        <rect width="24" height="24" fill="white" />
      </clipPath>
      <clipPath id="clip1_1406_7475">
        <rect width="20" height="20" fill="white" transform="translate(0 1)" />
      </clipPath>
      <clipPath id="clip2_1406_7475">
        <rect
          width="12"
          height="12"
          fill="white"
          transform="translate(11 10)"
        />
      </clipPath>
    </defs>
  </svg>
);
